/* ============
 * Mutations for the account module
 * ============
 *
 * The mutations that are available on the
 * account module.
 */


/* eslint-disable no-param-reassign */

import { GET_EXCHANGE_RATE } from './mutation-types';

export default {
  [GET_EXCHANGE_RATE](state, data) {
    state['currency'] = data.rates;
    state['currency_changes'] = data.changes;

    state['currency_loader'] = false;
  },
};
